import type { ChainId } from '@morpho-org/blue-sdk'
import { InterfaceChainUtils } from '@morpho-org/dapp-core'

import { trackAnalyticsEvent } from '../track'

function getChainName(chainId: ChainId): string {
  return InterfaceChainUtils.getMetadata(chainId).chainIdentifier
}

interface TrackNetworkFilterToggledParams {
  page: string
  toggledChainId: ChainId
  nextChainIds: ChainId[]
}

export function trackNetworkFilterToggled({
  page,
  toggledChainId,
  nextChainIds
}: TrackNetworkFilterToggledParams) {
  trackAnalyticsEvent('network_filter_changed', {
    page,
    chain_ids: nextChainIds,
    chain_names: nextChainIds.map(getChainName),
    selected_count: nextChainIds.length,
    action: 'toggle',
    toggled_chain_id: toggledChainId,
    toggled_chain_name: getChainName(toggledChainId)
  })
}

interface TrackNetworkFilterClearedParams {
  page: string
}

export function trackNetworkFilterCleared({ page }: TrackNetworkFilterClearedParams) {
  trackAnalyticsEvent('network_filter_changed', {
    page,
    chain_ids: [],
    chain_names: [],
    selected_count: 0,
    action: 'clear'
  })
}
